import {
  FETCH_DEFAULT_ASSESSMENTS,
  FETCH_DEFAULT_ASSESSMENTS_SUCCESS,
  FETCH_DEFAULT_ASSESSMENTS_ERROR,
  FETCH_MY_ASSESSMENTS,
  FETCH_MY_ASSESSMENTS_SUCCESS,
  FETCH_MY_ASSESSMENTS_ERROR,
  CREATE_ASSESSMENT,
  CREATE_ASSESSMENT_SUCCESS,
  CREATE_ASSESSMENT_ERROR,
  UPDATE_ASSESSMENT,
  UPDATE_ASSESSMENT_SUCCESS,
  UPDATE_ASSESSMENT_ERROR,
  DELETE_ASSESSMENT,
  DELETE_ASSESSMENT_SUCCESS,
  DELETE_ASSESSMENT_ERROR,
  CLEAR_ASSESSMENT_ERROR,
} from './constants';

const initialState = {
  defaultAssessments: { full: null, basic: null },
  defaultLoading: false,
  defaultError: null,
  myAssessments: [],
  myLoading: false,
  myError: null,
  createLoading: false,
  createError: null,
  updateLoading: false,
  updateError: null,
  deleteLoading: false,
  deleteError: null,
};

export default function adminAssessment(state = initialState, action) {
  switch (action.type) {
    case FETCH_DEFAULT_ASSESSMENTS:
      return { ...state, defaultLoading: true, defaultError: null };
    case FETCH_DEFAULT_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        defaultLoading: false,
        defaultAssessments: action.payload,
        defaultError: null,
      };
    case FETCH_DEFAULT_ASSESSMENTS_ERROR:
      return {
        ...state,
        defaultLoading: false,
        defaultError: action.error,
      };

    case FETCH_MY_ASSESSMENTS:
      return { ...state, myLoading: true, myError: null };
    case FETCH_MY_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        myLoading: false,
        myAssessments: action.list,
        myError: null,
      };
    case FETCH_MY_ASSESSMENTS_ERROR:
      return {
        ...state,
        myLoading: false,
        myError: action.error,
      };

    case CREATE_ASSESSMENT:
      return { ...state, createLoading: true, createError: null };
    case CREATE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        createLoading: false,
        myAssessments: [action.assessment, ...state.myAssessments],
        createError: null,
      };
    case CREATE_ASSESSMENT_ERROR:
      return {
        ...state,
        createLoading: false,
        createError: action.error,
      };

    case UPDATE_ASSESSMENT:
      return { ...state, updateLoading: true, updateError: null };
    case UPDATE_ASSESSMENT_SUCCESS: {
      const list = state.myAssessments.map((a) =>
        a._id === action.assessment._id ? action.assessment : a
      );
      return {
        ...state,
        updateLoading: false,
        myAssessments: list,
        updateError: null,
      };
    }
    case UPDATE_ASSESSMENT_ERROR:
      return {
        ...state,
        updateLoading: false,
        updateError: action.error,
      };

    case DELETE_ASSESSMENT:
      return { ...state, deleteLoading: true, deleteError: null };
    case DELETE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        myAssessments: state.myAssessments.filter((a) => a._id !== action.id),
        deleteError: null,
      };
    case DELETE_ASSESSMENT_ERROR:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error,
      };

    case CLEAR_ASSESSMENT_ERROR:
      return {
        ...state,
        createError: null,
        updateError: null,
        deleteError: null,
      };

    default:
      return state;
  }
}
